import React from 'react'
import PropTypes from "prop-types";

/**
 * Este componente renderiza la tercera sección del club MakeMake que corresponde a la información sobre los eventos y talleres que realizará MakeMake
 * y recibe como props los textos de la interfaz.
 */

const MakeMakeVivo = (props) => {

    const { traducciones } = props;

    return (
        <div className="pt-5">
            <div className="container">
                <div className="col-lg-10 mx-auto">
                    <div className=" row mx-0 justify-content-center">
                        <div className='col-12 px-0 px-sm-4 col-sm-9'>
                            <div className="d-lg-flex align-items-center justify-content-start">
                                <span className='numero-titles-rojo titulo-rojo-act d-flex justify-content-center align-items-center mx-auto mx-lg-0'>2</span>
                                <h2 className="titulos-actualizacion-club titulo-rojo-act mx-0 mx-lg-3 text-center text-lg-left ">{traducciones?.titulo || 'MakeMake en vivo'}</h2>
                            </div>
                        </div>
                        {/*Primera seccion*/}
                        <div className="col-lg-8 col-md-10 pt-3 justify-content-center align-items-center">
                            <p className="titulo-make-vivo px-0 px-xl-5 text-center text-lg-left" ><img src="/img/club-makemake/icon-2.png" className="img-fluid "></img>{traducciones?.fecha || 'Febrero 2023 a Diciembre 2023'}</p>
                        </div>
                    </div>
                    {/*Segunda seccion*/}
                    <div className='row py-5 pb-lg-0'>
                        <div className='col-lg-5 col-md-12 px-3 ' >
                            <strong className='mb-3 mb-lg-5 d-block onprimary--color'>
                                {traducciones?.canal?.descripcion?.parrafo_1 || 'Ciclo de eventos, charlas, talleres y foros con autores, ilustradores, músicos y profesionales especializados. En esta programación cultural y académica de primera línea, tendrás la oportunidad de conocer a tus autores y artistas favoritos y conocer más sobre temas relevantes en la educación lectora.'}
                            </strong>
                            <strong className='onprimary--color'>
                                {traducciones?.canal?.descripcion?.parrafo_2 || 'Realizaremos al menos un evento mensual y nuestra programación se divide en eventos públicos, abiertos para todos y 100% gratuitos, y eventos cerrados, exclusivos para nuestros suscriptores institucionales vigentes'}
                            </strong>
                        </div>
                        <div className='col-lg-7 pt-5 pt-lg-0'>
                            <div className='borde-amarillo mx-3'>
                                <div className='mx-3'>
                                    <img alt="make-ipad" src="/img/club-makemake/iconos-cerrar.png" className="img-fluid " />
                                </div>
                            </div>
                            <div className='contenedor-video mx-3'>
                                <div className='mx-3 mt-5'>
                                    <div className="embed-responsive embed-responsive-16by9">
                                        <iframe className="embed-responsive-item" src="https://www.youtube.com/embed/6NOQcLL9GDs"></iframe>
                                    </div>
                                </div>
                                <div className='d-sm-flex m-sm-3 m-3 justify-content-between align-items-center'>
                                    <div className='mr-3'>
                                        <img alt="make-ipad" src="/img/club-makemake/youtube.png" className="img-fluid d-none d-sm-block background-contraste" />
                                    </div>
                                    <div className='parrafo-youtube text-center text-sm-right'>{traducciones?.canal?.video?.texto || 'Sigue nuestro Canal de Youtube para ver todos los eventos pasados y recibir notificaciones de los eventos por venir.'}
                                    </div>
                                </div>
                                <div className='d-flex justify-content-center m-3 mb-5'>
                                    <a
                                        href="https://www.youtube.com/@makemake2206"
                                        target="_black"
                                        className="btn bnt-suscribete focusable-red mx-auto"
                                    >
                                        {traducciones?.canal?.video?.boton_suscribete || 'Suscríbete a nuestro canal'}
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                    {/*Tercera seccion*/}
                    <div className='row d-flex justify-content-center justify-content-lg-around' >
                        <div className='order-lg-0 order-sm-2 col-lg-5 col-md-7 py-md-5  d-flex align-items-center'>
                            <img alt="make-ipad" src="/img/club-makemake/makemake-vivo.png" className="img-fluid d-none d-md-block background-contraste" />
                        </div>
                        <div className='col-10 col-lg-6 d-flex justify-content-center align-items-center p-0'>
                            <div className=' pb-0 d-flex flex-column justify-content-center align-items-center contenedor-descarga'>
                                <div className='pt-3 px-4 pb-4 texto-programa'>
                                    <p>{traducciones?.descarga?.texto || 'Descarga el programa completo del 2023 y reserva las fechas para no perderte ninguno de nuestros eventos.'}</p>
                                </div>
                                <a
                                    href={traducciones?.descarga?.link_descarga || "/document/makemake_en_vivo_2023.pdf"}
                                    download={traducciones?.descarga?.nombre_archivo || 'makemake_en_vivo_2023.pdf'}
                                    className='py-3 btn bnt-descargar-programa  focusable-red'>
                                    {traducciones?.descarga?.boton_descarga || 'Descarga la programación del 2023'}
                                </a>
                            </div>
                        </div>
                        <div className="row order-lg-2 order-sm-1 col-lg-9 mx-auto">
                            <div>
                                <p className='titulo-planes titulo-violeta-act py-4 pt-xl-0'>
                                    {traducciones?.subtitulo || 'Programaciones anteriores:'}
                                </p>
                                <strong className=' onprimary--color pb-5'>
                                    {traducciones?.parrafo_1 || 'Puedes ver los eventos que te hayas perdido o repetir tus presentaciones favoritas. Toda nuestra programación queda grabada en nuestro canal de YouTube.'}
                                </strong>
                            </div>
                        </div>
                        <div className="d-lg-flex col-lg-12 col-md-4 col-sm-7 col-12 mx-auto py-5 pt-md-5 pb-md-0 order-lg-3 order-sm-3 justify-content-around align-items-center">
                            <div className="col-lg-4 pb-3 pb-lg-5 px-2 ">
                                <a
                                    href="https://www.youtube.com/playlist?list=PLOzDFiyCElH7hbDjZ8n6HE_jmLPW9WkYi"
                                    target="_black"
                                    className="btn btn-primary-act d-block mx-auto focusable-red"
                                >
                                    {traducciones?.botones_prog?.prog_2020 || 'Programación 2020'}
                                </a>
                            </div>
                            <div className="col-lg-4 pb-3 pb-lg-5 px-2 ">
                                <a
                                    href="https://www.youtube.com/playlist?list=PLOzDFiyCElH7zPY7KCBiHi6oopJvO0AYx"
                                    target="_black"
                                    className="btn btn-primary-act d-block mx-auto focusable-red"
                                >
                                    {traducciones?.botones_prog?.prog_2021 || 'Programación 2021'}</a>
                            </div>
                            <div className="col-lg-4 pb-3 pb-lg-5 px-2 ">
                                <a
                                    href="https://www.youtube.com/playlist?list=PLOzDFiyCElH6qdpXPwpaSZCcwS18rTkHG"
                                    target="_black"
                                    className="btn btn-primary-act d-block mx-auto focusable-red"
                                >
                                    {traducciones?.botones_prog?.prog_2022 || 'Programación 2022 '}
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div >
    )
}

export default MakeMakeVivo;

MakeMakeVivo.propTypes={
    /**
     * Es un objeto que trae los textos de la interfaz, especificamente los de mi cuenta. Estos cambian dependiendo del idioma activo.
     */
    traducciones: PropTypes.object.isRequired
}
